<template>
    <div>
        <v-row class="search-fields">
            <v-text-field 
                v-model="searchName" 
                placeholder="all" 
                label="Name" 
                outlined 
                dense 
                v-on:keyup.enter="search">
            </v-text-field>
            <v-select 
                v-model="searchLevel" 
                :items="levels"
                label="Level" 
                outlined 
                dense
                clearable
                v-on:keyup.enter="search">
            </v-select>
            <v-select
                v-model="searchSchool"
                :items="schools"
                label="School"
                dense
                outlined
                clearable
            ></v-select>
            <v-select
                v-model="searchClass"
                :items="classes"
                label="Class"
                dense
                outlined
                clearable
            ></v-select>
            <v-checkbox
                v-model="searchIsDamaging"
                label="Is Damaging"
                color="red darken-3"
                hide-details
            ></v-checkbox>
            <v-btn v-on:click="search">Search</v-btn>
            <v-spacer></v-spacer>
            <v-btn v-on:click="collapseAll">Collapse All</v-btn>
        </v-row>

        <v-data-table
            :headers="spellHeaders"
            :items="spellsArray"
            :expanded.sync="expanded"
            item-key="name"
            show-expand
            class="elevation-1"

            :items-per-page="-1"
            hide-default-footer

        >
            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                    <div class="item-contents">
                        <v-row>
                            <v-col>
                                <span class="detail-header">Description</span>
                                <br>
                                {{descriptionString(item)}}
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col v-if="hasDamage(item) && getDamage(item).length > 0">
                                <span v-if="item.damage.damage_at_slot_level !== undefined" class="detail-header">Damage at Slot Level:</span>
                                <span v-if="item.damage.damage_at_character_level !== undefined" class="detail-header">Damage at Character Level:</span>
                                <ul>
                                    <li v-for="item in getDamage(item)" :key="item">
                                        {{item}}
                                    </li>
                                </ul>
                            </v-col>

                            <v-col v-if="hasAreaOfEffect(item)">
                                <div>
                                    <span class="detail-header">Area of Effect</span>
                                    <ul>
                                        <li>Type: {{getAreaOfEffect(item)[0]}}</li>
                                        <li>Size: {{getAreaOfEffect(item)[1]}}</li>
                                    </ul>
                                </div>
                            </v-col>

                            <v-col>
                                <div>
                                    <span class="detail-header">Classes</span>
                                    <ul>
                                        <li v-for="item in getClasses(item)" :key="item">
                                            {{item}}
                                        </li>
                                    </ul>
                                </div>
                            </v-col>

                            <v-col v-if="getSubClasses(item).length>0">
                                <span class="detail-header">Subclasses</span>
                                <ul>
                                    <li v-for="item in getSubClasses(item)" :key="item">
                                        {{item}}
                                    </li>
                                </ul>
                            </v-col>

                            <v-col>
                                <div>
                                    <span class="detail-header">Components</span> 
                                    <ul>
                                        <li v-for="item in getComponents(item)" :key="item">
                                            {{item}}
                                        </li>
                                    </ul>
                                </div>
                            </v-col>

                            <v-col v-if="hasDc(item)">
                                <div>
                                    <span class="detail-header">DC</span>
                                    <ul>
                                        <li v-for="item in getDc(item)" :key="item">
                                            {{item}}
                                        </li>
                                    </ul>
                                </div>
                            </v-col>
                        </v-row>
                        
                        <div class="spell-type-area">
                            <div v-if="hasMaterial(item)">Material: {{getMaterial(item)}}</div>
                        </div>
                        <div class="spell-type-area">
                            <div v-if="isRitual(item)" class="ritual-spell">Ritual Spell</div>
                            <div v-if="isConcentration(item)" class="concentration-spell">Concentration Spell</div>
                        </div>
                    </div>
                </td>
            </template>
        </v-data-table>
    </div>
</template>


<script>
export default {
    props:["spells"],

    data () {
        return {
            searchName: "",
            searchLevel: "",
            searchSchool: "",
            searchClass: "",
            searchIsDamaging: false,

            expanded: [],
            singleExpand: false,
            spellHeaders: [
                {
                    text: 'Name',
                    align: 'start',
                    value: 'name',
                },
                { text: 'Level', value: 'level' },
                { text: 'School', value: 'school.name' },
                { text: 'Range', value: 'range', sortable: false, },
                { text: 'Casting Time', value: 'casting_time', sortable: false, },
                { text: 'Duration', value: 'duration', sortable: false, },
            ],
            spellsArray: [],

            schools: [
                "abjuration",
                "transmutation",
                "conjuration",
                "divination",
                "enchantment",
                "illusion",
                "evocation",
                "necromancy"
            ],

            classes: [
                "bard",
                "cleric",
                "druid",
                "paladin",
                "ranger",
                "sorcerer",
                "warlock",
                "wizard"
            ],

            levels: [
                "0",
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9"
            ],
        }
    },

    methods: {
        descriptionString(item) {
            let descString = "";
            item.desc.forEach(element => {
                descString += element + "\n"
            });
            return descString;
        },
        collapseAll() {
            this.expanded = [];
        },

        search() {
            this.spellsArray = this.spells.filter(this.searchFilter);
        },

        searchFilter(spell) {
            let isResult = true;
            if(this.searchName.length > 0 && isResult)
            {
                isResult = spell.name.toLowerCase().includes(this.searchName.toLowerCase());
            }
            if(this.searchLevel.length > 0 && isResult)
            {
                isResult = spell.level == this.searchLevel;
            }
            if(this.searchSchool.length > 0 && isResult)
            {
                isResult = spell.school.name.toLowerCase() == this.searchSchool.toLowerCase();
            }
            if(this.searchClass.length > 0 && isResult)
            {
                isResult = false;
                spell.classes.forEach(element => {
                    if(element.name.toLowerCase() === this.searchClass)
                    {
                        isResult = true;
                    }
                });
            }
            if(this.searchIsDamaging > 0 && isResult)
            {
                isResult = (spell.damage!== undefined)
            }
            return isResult;
        },
        isRitual(item) {
            return item.ritual;
        },
        isConcentration(item) {
            return item.concentration;
        },
        hasDamage(item) {
            return item.damage!== undefined
        },
        getDamage(item) {
            if(this.hasDamage(item))
            {
                let damageArray = []
                let isSlotDamageSpell = (item.damage.damage_at_slot_level !== undefined);
                let obj = isSlotDamageSpell ? item.damage.damage_at_slot_level : item.damage.damage_at_character_level; 

                for(const dam in obj) {
                    damageArray.push(`${dam}: ${obj[dam]}`);
                }

                return damageArray;
            }
        },
        hasAreaOfEffect(item) {
            return item.area_of_effect !== undefined
        },
        getAreaOfEffect(item) {
            if(this.hasAreaOfEffect(item))
            {
                let oaeArray = [];
                oaeArray.push(item.area_of_effect.type);
                oaeArray.push(item.area_of_effect.size);
                return oaeArray;
            }
            return [];
        },
        getClasses(item) {
            let classesArray = [];
            item.classes.forEach(element => {
                classesArray.push(element.name);
            });
            return classesArray;
        },
        getSubClasses(item) {
            let subClassesArray = [];
            item.subclasses.forEach(element => {
                subClassesArray.push(element.name);
            });
            return subClassesArray;
        },
        getComponents(item) {
            let componentsArray = [];
            item.components.forEach(element => {
                componentsArray.push(element);
            });
            return componentsArray;
        },
        hasMaterial(item) {
            return item.material !== undefined;
        },
        getMaterial(item) {
            if(this.hasMaterial(item))
            {
                return item.material;
            }
        },
        hasDc(item) {
            return item.dc !== undefined;
        },
        getDc(item) {
            if(this.hasDc(item))
            {
                let dcArray = [];
                let type =  "Type: " + item.dc.dc_type.name;
                let onSuccess = "On Success: " + item.dc.dc_success;

                dcArray.push(type);
                dcArray.push(onSuccess);
                return dcArray;
            }
        }
    },
    beforeMount: function() {
        this.spellsArray = this.spells;
    },
    watch: {
        searchClass: function(newVal) {
            if(newVal == null)
            {
                this.searchClass = "";
            }
        },
        searchSchool: function(newVal) {
            if(newVal == null)
            {
                this.searchSchool = "";
            }
        },
        searchLevel: function(newVal) {
            if(newVal == null)
            {
                this.searchLevel = "";
            }
        }
    }
    
}
</script>


<style scoped>
.search-fields {
    margin-bottom: 10px;
    /* margin-right: 10px; */
}
.v-text-field, .v-btn, .v-select, .v-checkbox {
    margin: 10px !important;
    max-width: 200px !important;
}
.item-contents {
    margin: 15px !important;
}
.concentration-spell {
    /* color: darkblue */
    color:lightblue;
}
.ritual-spell {
    /* color: purple; */
    color:lavender;
}
.spell-type-area {
    margin-top: 5px !important;
    margin-bottom: 5px !important;
}
.detail-header {
    font-weight: bold;
}

</style>
